import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Card, Flex, Typography } from 'antd'
import { path } from 'src/libs'
import { ExDifferenceListSection } from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/section'

export const ReportExDifference = () => {
  const navigate = useNavigate()
  const { Title, Text } = Typography

  return (
    <Flex vertical gap="middle">
      <Breadcrumb
        items={[
          {
            title: (
              <Text
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                  fontSize: 16,
                }}
                onClick={() => navigate(path.finSystem.balanceSummary.entry())}
              >
                Financial statement
              </Text>
            ),
          },
          {
            title: (
              <Text type="secondary" style={{ fontSize: 16 }}>
                Exchange difference
              </Text>
            ),
          },
        ]}
      />
      <Title level={1} style={{ marginBottom: 0 }}>
        Exchange difference
      </Title>
      <Card>
        <ExDifferenceListSection />
      </Card>
    </Flex>
  )
}
